import "../styles/legal.css"
import { useNavigate } from "react-router-dom"

export default function TermsPage() {
    const nav = useNavigate()
    return (
        <div className="legal-page">
            <nav className="legal-nav">
                <span className="legal-logo" onClick={() => nav("/")}>ArbSignal</span>
            </nav>

            <div className="legal-content">
                <h1>Terms of Service</h1>
                <p className="legal-updated">Last updated: April 2026</p>

                <h2>1. About ArbSignal</h2>
                <p>ArbSignal ("we", "us") provides a software service that monitors cryptocurrency
                    price spreads across multiple exchanges and notifies users of arbitrage opportunities.</p>

                <h2>2. Not financial advice</h2>
                <p><strong>ArbSignal is an information tool, not a financial advisor.</strong> The signals
                    we provide are based on raw market data and do not constitute investment, trading,
                    or financial advice. You are solely responsible for any trades you make based on our data.
                    Cryptocurrency trading carries substantial risk of loss.</p>

                <h2>3. Account responsibilities</h2>
                <ul>
                    <li>You must be at least 18 years old</li>
                    <li>You must provide accurate registration information</li>
                    <li>You are responsible for maintaining password confidentiality</li>
                    <li>Disposable email addresses are not permitted</li>
                </ul>

                <h2>4. Acceptable use</h2>
                <p>You may not:</p>
                <ul>
                    <li>Resell ArbSignal data or alerts to third parties</li>
                    <li>Reverse engineer or scrape our API beyond rate limits</li>
                    <li>Share your account credentials with others</li>
                    <li>Use the service for unlawful trading activities</li>
                </ul>

                <h2>5. Free trial</h2>
                <p>New users receive a 30-day free trial with full Pro features. After the trial,
                    your account becomes read-only with delayed data unless you subscribe.</p>

                <h2>6. Subscription and payment</h2>
                <p>Subscriptions auto-renew monthly until canceled. Payments are processed by
                    Dodo Payments (our Merchant of Record). All prices in USD unless otherwise noted.</p>

                <h2>7. Refunds</h2>
                <p>See our <a href="/refund">Refund Policy</a> for details. Summary: 30-day money-back
                    guarantee on first subscription.</p>

                <h2>8. Service availability</h2>
                <p>We aim for 99.5% uptime but cannot guarantee uninterrupted service. Crypto exchange
                    APIs may go down or change at any time, which may cause data delays or gaps.
                    We are not liable for trades made during such outages.</p>

                <h2>9. Limitation of liability</h2>
                <p>To the maximum extent permitted by law, ArbSignal is not liable for any direct,
                    indirect, incidental, or consequential damages arising from your use of the service,
                    including but not limited to trading losses.</p>

                <h2>10. Termination</h2>
                <p>We may suspend or terminate accounts that violate these terms. You may cancel your
                    subscription at any time from the dashboard.</p>

                <h2>11. Changes to these terms</h2>
                <p>We may update these terms occasionally. Continued use of the service after changes
                    constitutes acceptance.</p>

                <h2>12. Governing law</h2>
                <p>These terms are governed by the laws of Georgia (country). Disputes will be resolved
                    in Tbilisi courts.</p>

                <h2>Contact</h2>
                <p>Questions? Email <a href="mailto:support@arb-signal.com">support@arb-signal.com</a></p>
            </div>
        </div>
    )
}
